import React from 'react'
import { useSelector } from "react-redux";
import { getContactUsErrors, getContactUsStatus, selectContactUsInfo } from '../../reducers/resumeSlice'
import FormComment from './formComment'
import ContactBoxes from './contactBoxes'
import LoaderContactBoxes from './LoderContactBoxes'

export default function ContactUs() {

    const contactUsInfo = useSelector(selectContactUsInfo)
    // console.log(contactUsInfo);

    return (
        <section data-id="contact" className="animated-section contact">
            {/* <!-- start section-content --> */}
            <div className="section-content">
                <div className="page-title">
                    <h2>تماس با ما</h2>
                    <h4>لورم ایپسوم</h4>
                </div>

                {contactUsInfo !== null ? <ContactBoxes contactUsInfo={contactUsInfo} /> : <LoaderContactBoxes />}

                <FormComment />
            </div>
            {/* start section-content */}
        </section>
    )
}
